import { ReactNode } from "react";
import { PRODUCT_ACCENT_COLORS } from "../../constants/productLogos";

export interface NavLink {
  id: string;
  label?: string;
  url?: string;
  isSubLinks?: boolean;
  sublinks?: NavLink[];
  shouldOpenNewTab?: boolean;
  icon?: ReactNode;
}

export interface ProductDropdownItem {
  id: string | number;
  name: string;
  icon?: string;
  accentColor?: string;
  link?: string;
}

export interface WorkspaceSidebarProps {
  navItems: NavLink[];
  selectedItem?: string;
  onSelect: (url: string) => void;
  workspaceName: string;
  workspaceIconSrc?: string;
  workspaceAccentColor?: string;
  showProductSwitcher?: boolean;
  groupIcon?: ReactNode;
  isProductDropdownOpen?: boolean;
  productItems?: ProductDropdownItem[];
  onProductSwitcherClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onProductSelect?: (item: ProductDropdownItem) => void;
  userName?: string;
  userRole?: string;
  onSettingsClick?: () => void;
}

export const SIDEBAR_WIDTH = 260;
export const WORKSPACE_NAME_EVES = "Eves Ops";
export const WORKSPACE_ACCENT_EVES = PRODUCT_ACCENT_COLORS.EvesSysAdmin;

export const normalizeNavUrl = (url: string) =>
  url.startsWith("/") ? url : `/${url}`;
